export default  {
  // inputPlaceholder: '请输入',
}